<script lang="ts" setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();

const currentRouteName = computed(() => {
  return route.name;
});
</script>


<template>
  <header>
    <div class="row">
      <div class="column">
        <div class="logo">
          <router-link :to="{ name: 'home' }" tabIndex="0">
            <img alt="" src="@/assets/img/digital-vereint-logo.png">
          </router-link>
        </div>

        <div class="context">
          <div v-if="currentRouteName === 'home'">
            Wir digitalisieren mit euch das Ehrenamt in Bayern.
          </div>
          <div v-else>
            <router-link class="back" to="/">
              &laquo; Zurück zur Startseite
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>


<style lang="scss" scoped>
@import '@/assets/scss/typography.scss';

header {
  text-align: center;

  .row:nth-child(odd) {
    background: $color-light;
  }

  .row .column {
    padding: 0 2em 2.25em;
  }

  .logo {
    a {
      display: inline-block;
      overflow: hidden;
    }

    img {
      width: 16em;
      margin: 1.5em;
      padding: 0.5em;
    }

    a:focus-visible {
      background: none;

      img {
        outline: $outline;
      }
    }
  }

  .context {
    margin-top: -1em;
    text-align: center;
    font-size: $font-size-small;
  }
}
</style>